import { render, staticRenderFns } from "./ImgSwiper.vue?vue&type=template&id=04355a9d&scoped=true"
import script from "./ImgSwiper.vue?vue&type=script&lang=js"
export * from "./ImgSwiper.vue?vue&type=script&lang=js"
import style0 from "./ImgSwiper.vue?vue&type=style&index=0&id=04355a9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04355a9d",
  null
  
)

export default component.exports